import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  constructor(
    private _snackBar: MatSnackBar
  ) { }

  private notificationComponent: any;

  setNotificationComponent(component: any) {
    this.notificationComponent = component;
  }

  /**
   *
   * @param text
   * @param action "Success" - "Error" - "Warning" - "Info"
   * @param seconds time
   * @returns
   */
  show(text: string, action: string, seconds = 5) {
    //Todo:Bruno change action to enumn and based of that show Toaster icon + correct color
    return this._snackBar.openFromComponent(this.notificationComponent, {
      data: {
        message: text,
        type: action
      },
      duration: seconds * 1000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    })
  }

  showError(text: string, action = 'Error') {
    //Todo:Bruno change action to enumn and based of that show Toaster icon + correct color
    return this._snackBar.openFromComponent(this.notificationComponent, {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: {
        message: text,
        type: action
      },
      duration: 5000
    })
  }

}
